export default __webpack_public_path__ + "static/media/1913.854ae984.png";